<template>
    <cmpRec v-bind:name="name"
                   v-bind:pkColumn="pkColumn"
                   v-bind:fields="fields"
                   v-bind:parent="parent"
                   v-bind:header="header"></cmpRec>
</template>

<script>
    import i18n from '@/i18n'
    import cmpRec from "@/components/common/cmpRec"

    export default {
        components: {
            cmpRec
        },
        computed: {
            fields() {
                return [
                    { "key": "UserName", "label": i18n.t('component.ActivityParticipant.UserName.label') },
                    { "key": "ProjectRoleName", "label": i18n.t('component.ActivityParticipant.ProjectRoleName.label') }
                ]
            },
            header() {
                return i18n.t('component.ActivityParticipant.recHeader')
            }
        },
        data() {

            return {
                name: "ActivityParticipant",
                pkColumn: "ActivityParticipantId",
                parent: { "name": "Activity", "key": "ActivityId" },
            };
        }
    }
</script>